import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../state/refresh'
import { useRequests } from '../requests/useRequests'

const ForgotPassword = (): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const requestMaker = useRequests()
  const [emailOrUsername, setEmailOrUsername] = useState('')
  const [code, setCode] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [emailError, setEmailError] = useState<string | null>(null)
  const [codeError, setCodeError] = useState<string | null>(null)
  const [passwordError, setPasswordError] = useState<string | null>(null)
  const [confirmPasswordError, setConfirmPasswordError] = useState<string | null>(null)
  const [isCodeSent, setIsCodeSent] = useState(false)
  const [isCodeValidated, setIsCodeValidated] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleSendCode = async (e?: React.FormEvent) => {
    if (e != null) e.preventDefault()
    setIsLoading(true)
    if (!emailOrUsername) {
      setEmailError('Pole jest wymagane')
      setIsLoading(false)
      return
    }
    try {
      await requestMaker.sendForgotPasswordCode(emailOrUsername)
      setIsCodeSent(true)
      dispatch(RefreshActions.setToastMessage({ message: 'Kod został wysłany na podany adres email' }))
    } catch (e) {
      setEmailError('Nie znaleziono użytkownika o podanym adresie email lub nazwie użytkownika lub użytkownik ma niepotwierdzony adres email')
    }
    setIsLoading(false)
  }

  const handleValidateCode = async (e?: React.FormEvent) => {
    if (e != null) e.preventDefault()
    setIsLoading(true)
    if (!code) {
      setCodeError('Pole jest wymagane')
      setIsLoading(false)
      return
    }
    try {
      await requestMaker.validateForgotPasswordCode(emailOrUsername, code)
      setIsCodeValidated(true)
      dispatch(RefreshActions.setToastMessage({ message: 'Kod został zweryfikowany' }))
    } catch (e) {
      setCodeError('Nieprawidłowy kod')
    }
    setIsLoading(false)
  }

  const handleChangePassword = async (e?: React.FormEvent) => {
    if (e != null) e.preventDefault()
    setIsLoading(true)
    if (!newPassword) {
      setPasswordError('Pole jest wymagane')
      setIsLoading(false)
      return
    }
    if (!confirmPassword) {
      setConfirmPasswordError('Pole jest wymagane')
      setIsLoading(false)
      return
    }
    if (newPassword !== confirmPassword) {
      setConfirmPasswordError('Hasła nie są identyczne')
      setIsLoading(false)
      return
    }
    try {
      await requestMaker.changeForgottenPassword(emailOrUsername, code, newPassword)
      dispatch(RefreshActions.setToastMessage({ message: 'Hasło zostało zmienione' }))
      navigate('/login')
    } catch (e) {
      setPasswordError('Wystąpił błąd podczas zmiany hasła')
    }
    setIsLoading(false)
  }

  return (
    <div className='auth-page'>
      <div className='auth-container'>
        <h1 className='auth-title'>Odzyskiwanie hasła</h1>
        <p className='auth-description'>
          Wprowadź swój login lub email, aby otrzymać kod do zmiany hasła.
        </p>
        <form
          className='auth-form' onSubmit={
          !isCodeSent ? handleSendCode : !isCodeValidated ? handleValidateCode : handleChangePassword
        }
        >
          {!isCodeSent && (
            <div className='form-group'>
              <input
                type='text'
                className={`form-control ${emailError ? 'error' : ''}`}
                placeholder='Login lub Email'
                value={emailOrUsername}
                onChange={e => {
                  setEmailError(null)
                  setEmailOrUsername(e.target.value)
                }}
                required
              />
              {emailError && <div className='error-text'>{emailError}</div>}
            </div>
          )}
          {isCodeSent && !isCodeValidated && (
            <div className='form-group'>
              <input
                type='text'
                className={`form-control ${codeError ? 'error' : ''}`}
                placeholder='Kod weryfikacyjny'
                value={code}
                onChange={e => {
                  setCodeError(null)
                  setCode(e.target.value)
                }}
                required
              />
              {codeError && <div className='error-text'>{codeError}</div>}
            </div>
          )}
          {isCodeSent && isCodeValidated && (
            <>
              <div className='form-group'>
                <input
                  type='password'
                  className={`form-control ${passwordError ? 'error' : ''}`}
                  placeholder='Nowe hasło'
                  value={newPassword}
                  onChange={e => {
                    setPasswordError(null)
                    setNewPassword(e.target.value)
                  }}
                  required
                />
                {passwordError && <div className='error-text'>{passwordError}</div>}
              </div>
              <div className='form-group'>
                <input
                  type='password'
                  className={`form-control ${confirmPasswordError ? 'error' : ''}`}
                  placeholder='Potwierdź hasło'
                  value={confirmPassword}
                  onChange={e => {
                    setConfirmPasswordError(null)
                    setConfirmPassword(e.target.value)
                  }}
                  required
                />
                {confirmPasswordError && <div className='error-text'>{confirmPasswordError}</div>}
              </div>
            </>
          )}
          <button
            type='submit'
            className='btn-primary'
            disabled={isLoading || (!isCodeSent && !emailOrUsername) || (isCodeSent && !isCodeValidated && !code) || (isCodeSent && isCodeValidated && (!newPassword || !confirmPassword))}
          >
            {isLoading
              ? 'Przetwarzanie...'
              : !isCodeSent
                  ? 'Wyślij kod'
                  : !isCodeValidated
                      ? 'Weryfikuj kod'
                      : 'Zmień hasło'}
          </button>
        </form>
        <div className='auth-footer'>
          <button className='register-link' onClick={() => navigate('/login')}>
            Wróć do logowania
          </button>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
